import FiniquitoMdl from '@/models/HumanResource/HRFiniquito'
export default async data => {
    try {
        const response = await new FiniquitoMdl(data).save()
        return response
    } catch (error) {
        return error.response.data
    }
}
